import { Component, ChangeDetectionStrategy, input, output, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';
import { GuestReservationSource } from 'src/models/guest-reservations';

@Component({
  selector: 'channel-sync-indicator',
  templateUrl: './channel-sync-indicator.component.html',
  styleUrls: ['./channel-sync-indicator.component.scss'],
  standalone: true,
  imports: [CommonModule, TidyUiComponentsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChannelSyncIndicatorComponent {
  channels = input.required<GuestReservationSource[]>();
  maxVisible = input<number>(3);
  compact = input<boolean>(false);
  clicked = output<void>();

  // Always include iCal as a static "channel"
  icalChannel = {
    id: -1,
    guest_reservation_source_type: {
      logo_url: 'assets/svg/calendar-outline.svg',
      name: 'iCal Export'
    }
  };

  allChannels = computed(() => [this.icalChannel as any, ...this.channels()]);
  visibleChannels = computed(() => this.allChannels().slice(0, this.maxVisible()));
  remainingCount = computed(() => Math.max(0, this.allChannels().length - this.maxVisible()));

  onIndicatorClick() {
    this.clicked.emit();
  }
}
